import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useParams, Navigate } from 'react-router-dom';

import client from './contentfulClientToken.js';

// import Header from './components/Header';
import Home from './pages/Home.js';
import Portraits from './pages/Portraits.js';
import Commissions from './pages/Commissions.js';
import CommissionsSlider from './pages/CommissionsSlider.js';
import Portraits02Slider from './pages/Portraits02Slider.js';
import Events from './pages/Events.js';
import EventsSlider from './pages/EventsSlider.js';
import Artworks from './pages/Artworks.js';
import ArtworksSlider from './pages/ArtworksSlider.js';

import './App.scss';
import Info from './pages/Info.js';
import Imprint from './pages/Imprint.js';
import Portraits02 from './pages/Portraits02.js';
// import HeaderHome from './components/HeaderHome';
/* import PortraitsSlider from './pages/PortraitsSlider'; */

function DynamicProject({ commissions, artworks, events, portraits02, commissionsLoading = true, artworksLoading = true, eventsLoading = false, portraits02Loading = true, buttons = null }) {
  const { slug } = useParams();
  const commission = commissions.find(comm => comm.slug === slug);
  const artwork = artworks.find(art => art.slug === slug);
  const event = events.find(evt => evt.slug === slug);
  const portrait02 = portraits02.find(p => p.slug === slug);
  const isLoading = commissionsLoading || artworksLoading || eventsLoading || portraits02Loading;

  if (commission) {
    return <CommissionsSlider commissions={commissions} loading={commissionsLoading} buttons={buttons} />;
  }
  if (portrait02) {
    return <Portraits02Slider portraits02={portraits02} loading={portraits02Loading} buttons={buttons} />;
  }
  if (artwork) {
    return <ArtworksSlider artworks={artworks} loading={artworksLoading} buttons={buttons} />;
  }
  if (event) {
    return <EventsSlider events={events} loading={eventsLoading} buttons={buttons} />;
  }
  // Redirect to home if loading is complete and project not found
  if (!isLoading) {
    return <Navigate to="/" replace />;
  }
  return null;
}

function App() {

  const [portraits, setPortraits] = useState([]);
  const [portraits02, setPortraits02] = useState([]);

  const [portraitsLoading, setPortraitsLoading] = useState(true);
  const [portraits02Loading, setPortraits02Loading] = useState(true);
  const [commissions, setCommissions] = useState([]);
  const [events, setEvents] = useState([]);
  const [commissionsLoading, setCommissionsLoading] = useState(true);
  const [eventsLoading, setEventsLoading] = useState(true);
  const [artworks, setArtworks] = useState([]);
  const [artworksLoading, setArtworksLoading] = useState(true);
  const [highlights, setHighlights] = useState([]);
  const [fullScreenPictures, setFullScreenPictures] = useState([]);
  const [biography, setBiography] = useState([]);
  const [info, setInfo] = useState([]);
  const [imprint, setImprint] = useState([]);
  const [buttons, setButtons] = useState(null);

  window.addEventListener(
    'contextmenu',
    function (e) {
      e.preventDefault();
    },
    false
  );


  useEffect(() => {
    const fetchPortraits = async () => {
      try {
        setPortraitsLoading(true);
        const response = await client.getEntry('3EfpR8yasuCN8gvhgB0kZa', {
          include: 2
        });

        // console.log('Portraits:', response);

        // Get the array of pictures directly from the fields
        const pictures = response.fields.pictures || [];

        // Map each picture to the required format, preserving Contentful structure for image optimization
        const portraits = pictures
          .filter(picture => picture && picture.fields && picture.fields.file && picture.fields.file.url)
          .map(picture => ({
            title: picture.fields.title || '',
            // Preserve the original Contentful structure for image optimization
            fields: {
              file: picture.fields.file
            },
            // Also provide a direct URL for backward compatibility
            url: picture.fields.file.url.startsWith('//')
              ? `https:${picture.fields.file.url}`
              : picture.fields.file.url,
            id: picture.sys?.id || ''
          }));

        setPortraits(portraits);

      } catch (error) {
        console.error('Error fetching portraits:', error);
      } finally {
        setPortraitsLoading(false);
      }
    };
    fetchPortraits();
  }, []);

  useEffect(() => {
    const fetchPortraits02 = async () => {
      try {
        setPortraits02Loading(true);
        const galleryResponse = await client.getEntry('4KfVnDm8I01EDHjY6RRmtp', {
          include: 2
        });

        //console.log('Portraits02 gallery:', galleryResponse);

        // Get the ordered array of entries directly from fields (same structure as commissions)
        const portraitRefs = galleryResponse.fields.commissions || [];

        // Map each entry to the required format (mirroring commissions)
        const processedPortraits02 = portraitRefs
          .filter(entry => entry && entry.fields)
          .map(entry => ({
            title: entry.fields.title,
            slug: entry.fields.url,
            texte: entry.fields.texte,
            textTitle: entry.fields.textTitle,
            mainPicture: (entry.fields.mainPicture && entry.fields.mainPicture.fields && entry.fields.mainPicture.fields.file && entry.fields.mainPicture.fields.file.url) ? {
              title: entry.fields.mainPicture.fields.title || '',
              description: entry.fields.mainPicture.fields.description || '',
              fields: {
                file: entry.fields.mainPicture.fields.file
              },
              url: entry.fields.mainPicture.fields.file.url.startsWith('//')
                ? `https:${entry.fields.mainPicture.fields.file.url}`
                : entry.fields.mainPicture.fields.file.url
            } : null,
            sliderPictures: Array.isArray(entry.fields.sliderPictures)
              ? entry.fields.sliderPictures
                .filter(picture => picture && picture.fields && picture.fields.file && picture.fields.file.url)
                .map(picture => ({
                  title: picture.fields.title || '',
                  description: picture.fields.description || '',
                  url: picture.fields.file.url.startsWith('//')
                    ? `https:${picture.fields.file.url}`
                    : picture.fields.file.url
                }))
              : []
          }));

        setPortraits02(processedPortraits02);

      } catch (error) {
        console.error('Error fetching portraits02:', error);
      } finally {
        setPortraits02Loading(false);
      }
    };
    fetchPortraits02();
  }, []);

  useEffect(() => {
    const fetchCommissions = async () => {
      try {
        setCommissionsLoading(true);
        const galleryResponse = await client.getEntry('4Own9oeQO01t2Vj4nTbNcR', {
          include: 2
        });

        /*   console.log('Commissions:', galleryResponse); */
        // console.log('Commissions:', galleryResponse);

        // Get the ordered array of commissions directly from fields
        const commissionRefs = galleryResponse.fields.commissions || [];

        // Map each commission to the required format
        const processedCommissions = commissionRefs
          .filter(commission => commission && commission.fields) // Filter out draft/unpublished entries
          .map(commission => ({
            title: commission.fields.title,
            //secondLine: commission.fields.secondLineDescription,
            slug: commission.fields.url,
            texte: commission.fields.texte,
            textTitle: commission.fields.textTitle,
            mainPicture: (commission.fields.mainPicture && commission.fields.mainPicture.fields && commission.fields.mainPicture.fields.file && commission.fields.mainPicture.fields.file.url) ? {
              title: commission.fields.mainPicture.fields.title || '',
              description: commission.fields.mainPicture.fields.description || '',
              // Preserve the original Contentful structure for image optimization
              fields: {
                file: commission.fields.mainPicture.fields.file
              },
              // Also provide a direct URL for backward compatibility
              url: commission.fields.mainPicture.fields.file.url.startsWith('//')
                ? `https:${commission.fields.mainPicture.fields.file.url}`
                : commission.fields.mainPicture.fields.file.url
            } : null,
            sliderPictures: Array.isArray(commission.fields.sliderPictures)
              ? commission.fields.sliderPictures
                .filter(picture => picture && picture.fields && picture.fields.file && picture.fields.file.url)
                .map(picture => ({
                  title: picture.fields.title || '',
                  description: picture.fields.description || '',
                  url: picture.fields.file.url.startsWith('//')
                    ? `https:${picture.fields.file.url}`
                    : picture.fields.file.url
                }))
              : []
          }));

        setCommissions(processedCommissions);

      } catch (error) {
        console.error('Error fetching commissions:', error);
      } finally {
        setCommissionsLoading(false);
      }
    };
    fetchCommissions();
  }, []);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        setEventsLoading(true);
        const galleryResponse = await client.getEntry('7E3kpoIX0OrILdsjLBqayw', {
          include: 2
        });

        //.log('Events:', galleryResponse);
        // console.log('Events fields keys:', Object.keys(galleryResponse.fields));

        const eventRefs = galleryResponse.fields.commissions || [];

        const processedEvents = eventRefs
          .filter(event => event && event.fields)
          .map(event => ({
            title: event.fields.title,
            slug: event.fields.url,
            texte: event.fields.texte,
            textTitle: event.fields.textTitle,
            mainPicture: (event.fields.mainPicture && event.fields.mainPicture.fields && event.fields.mainPicture.fields.file && event.fields.mainPicture.fields.file.url) ? {
              title: event.fields.mainPicture.fields.title || '',
              description: event.fields.mainPicture.fields.description || '',
              fields: {
                file: event.fields.mainPicture.fields.file
              },
              url: event.fields.mainPicture.fields.file.url.startsWith('//')
                ? `https:${event.fields.mainPicture.fields.file.url}`
                : event.fields.mainPicture.fields.file.url
            } : null,
            sliderPictures: Array.isArray(event.fields.sliderPictures)
              ? event.fields.sliderPictures
                .filter(picture => picture && picture.fields && picture.fields.file && picture.fields.file.url)
                .map(picture => ({
                  title: picture.fields.title || '',
                  description: picture.fields.description || '',
                  url: picture.fields.file.url.startsWith('//')
                    ? `https:${picture.fields.file.url}`
                    : picture.fields.file.url
                }))
              : []
          }));

        setEvents(processedEvents);
      } catch (error) {
        console.error('Error fetching events:', error);
      } finally {
        setEventsLoading(false);
      }
    };
    fetchEvents();
  }, []);

  useEffect(() => {
    const fetchArtworks = async () => {
      try {
        setArtworksLoading(true);
        const galleryResponse = await client.getEntry('43rImw8Ov05oLTdmdzX2FQ', {
          include: 2
        });

        // console.log('Artworks:', galleryResponse);
        // Get the ordered array of exhibitions directly from fields
        const exhibitionRefs = galleryResponse.fields.exhibitions || [];

        // Map each exhibition to the required format
        const processedArtworks = exhibitionRefs
          .filter(artwork => artwork && artwork.fields) // Filter out draft/unpublished entries
          .map(artwork => ({
            title: artwork.fields.title,
            //secondLine: artwork.fields.secondLineDescription,
            slug: artwork.fields.url,
            texte: artwork.fields.texte,
            textTitle: artwork.fields.textTitle,
            mainPicture: (artwork.fields.mainPicture && artwork.fields.mainPicture.fields && artwork.fields.mainPicture.fields.file && artwork.fields.mainPicture.fields.file.url) ? {
              title: artwork.fields.mainPicture.fields.title || '',
              description: artwork.fields.mainPicture.fields.description || '',
              // Preserve the original Contentful structure for image optimization
              fields: {
                file: artwork.fields.mainPicture.fields.file
              },
              // Also provide a direct URL for backward compatibility
              url: artwork.fields.mainPicture.fields.file.url.startsWith('//')
                ? `https:${artwork.fields.mainPicture.fields.file.url}`
                : artwork.fields.mainPicture.fields.file.url
            } : null,
            sliderPictures: Array.isArray(artwork.fields.sliderPictures)
              ? artwork.fields.sliderPictures
                .filter(picture => picture && picture.fields && picture.fields.file && picture.fields.file.url)
                .map(picture => ({
                  title: picture.fields.title || '',
                  description: picture.fields.description || '',
                  url: picture.fields.file.url.startsWith('//')
                    ? `https:${picture.fields.file.url}`
                    : picture.fields.file.url
                }))
              : []
          }));

        setArtworks(processedArtworks);

      } catch (error) {
        console.error('Error fetching artworks:', error);
      } finally {
        setArtworksLoading(false);
      }
    };
    fetchArtworks();
  }, []);

  useEffect(() => {
    const fetchFullScreenPictures = async () => {
      try {
        const fullScreenPicturesResponse = await client.getEntry('LX6lthT8wmc4wyU9x0Ddz', {
          include: 2
        });

        // Get the array of full screen pictures directly from the fields
        const pictures = fullScreenPicturesResponse.fields.fullScreenPictures || [];

        // Map each picture to the required format
        const processedFullScreenPictures = pictures
          .filter(picture => picture && picture.fields && picture.fields.file && picture.fields.file.url)
          .map(picture => ({
            title: picture.fields.title || '',
            url: picture.fields.file.url.startsWith('//')
              ? `https:${picture.fields.file.url}`
              : picture.fields.file.url,
            id: picture.sys?.id || ''
          }));

        setFullScreenPictures(processedFullScreenPictures);

      } catch (error) {
        console.error('Error fetching entrance pictures:', error);
      }
    };
    fetchFullScreenPictures();
  }, []);

  useEffect(() => {
    const fetchHighlights = async () => {
      try {
        const response = await client.getEntry('2SNpc8Ymh4Mj4qIuIzA8at', {
          include: 2
        });

        // Get the array of highlights directly from the fields
        const highlights = response.fields.highlights || [];

        // Map each highlight to the required format, preserving Contentful structure for image optimization
        const processedHighlights = highlights.map(highlight => ({
          title: highlight.fields.title,
          url: highlight.fields.url,
          picture: (highlight.fields.picture && highlight.fields.picture.fields && highlight.fields.picture.fields.file && highlight.fields.picture.fields.file.url)
            ? {
              title: highlight.fields.picture.fields.title || '',
              description: highlight.fields.picture.fields.description || '',
              // Preserve the original Contentful structure for image optimization
              fields: {
                file: highlight.fields.picture.fields.file
              },
              // Also provide a direct URL for backward compatibility
              url: highlight.fields.picture.fields.file.url.startsWith('//')
                ? `https:${highlight.fields.picture.fields.file.url}`
                : highlight.fields.picture.fields.file.url
            }
            : null,
          id: highlight.sys.id
        }));

        setHighlights(processedHighlights);

      } catch (error) {
        console.error('Error fetching highlights:', error);
      }
    };
    fetchHighlights();
  }, []);

  useEffect(() => {
    const fetchBiography = async () => {
      try {
        const biographyResponse = await client.getEntry('4fm6jrSZL7RZ3JOI94IIV2', {
          include: 2
        });

        //console.log('Biography:', biographyResponse);
        // Process biography data
        const bioAsset = biographyResponse.fields.bioPicture;
        const hasBioAsset = !!(bioAsset && bioAsset.fields && bioAsset.fields.file && bioAsset.fields.file.url);
        const processedBiography = {
          bioText: biographyResponse.fields.bioText,
          backgroundColor: biographyResponse.fields.backgroundColor,
          bioPicture: hasBioAsset ? {
            title: bioAsset.fields.title || '',
            url: bioAsset.fields.file.url.startsWith('//')
              ? `https:${bioAsset.fields.file.url}`
              : bioAsset.fields.file.url,
            // Preserve the original Contentful structure for image optimization
            backgroundColor: bioAsset.fields.backgroundColor,
            fields: {
              file: bioAsset.fields.file
            }
          } : null
        };

        setBiography(processedBiography);

      } catch (error) {
        console.error('Error fetching biography:', error);
      }
    };
    fetchBiography();
  }, []);

  useEffect(() => {
    const fetchInfo = async () => {
      try {
        const infoResponse = await client.getEntry('jHInGCLzcUPnBVZJnDnao', {
          include: 2
        });

        //console.log('Info:', infoResponse);

        const processedInfo = {
          infoText: infoResponse.fields.infoText,
        };


        setInfo(processedInfo);

      } catch (error) {
        console.error('Error fetching info:', error);
      }
    };
    fetchInfo();
  }, []);

  useEffect(() => {
    const fetchImprint = async () => {
      try {
        const imprintResponse = await client.getEntry('2px44TjcJxIuFaH5zVsVUJ', {
          include: 2
        });

        //console.log('Imprint:', imprintResponse);

        const processedImprint = {
          imprintText: imprintResponse.fields.imprintText,
        };


        setImprint(processedImprint);

      } catch (error) {
        console.error('Error fetching imprint:', error);
      }
    };
    fetchImprint();
  }, []);

  useEffect(() => {
    const fetchButtons = async () => {
      try {
        const buttonsResponse = await client.getEntry('3F5DO1PsYmMf3hyLMAox7o', {
          include: 2
        });

        console.log('Buttons:', buttonsResponse);


        setButtons(buttonsResponse);

      } catch (error) {
        console.error('Error fetching buttons:', error);
      }
    };
    fetchButtons();
  }, []);


  return (
    <Router>

      <Routes>
        <Route path="/" element={<Home highlights={highlights} fullScreenPictures={fullScreenPictures} biography={biography} buttons={buttons} />} />
        <Route path="/portraits" element={<Portraits portraits={portraits} loading={portraitsLoading} buttons={buttons} />} />
        <Route path="/portraits-02" element={<Portraits02 portraits02={portraits02} loading={portraits02Loading} buttons={buttons} />} />

        <Route path="/commissions" element={<Commissions commissions={commissions} buttons={buttons} />} />
        <Route path="/events" element={<Events events={events} buttons={buttons} />} />
        <Route path="/artworks" element={<Artworks artworks={artworks} buttons={buttons} />} />
        <Route path="/info" element={<Info info={info} buttons={buttons} />} />
        <Route path="/imprint" element={<Imprint imprint={imprint} buttons={buttons} />} />

        <Route path="/:slug" element={<DynamicProject commissions={commissions} artworks={artworks} events={events} portraits02={portraits02} commissionsLoading={commissionsLoading} artworksLoading={artworksLoading} eventsLoading={eventsLoading} portraits02Loading={portraits02Loading} buttons={buttons} />} />
        <Route path="*" element={<Navigate to="/" replace />} />

      </Routes>
    </Router>
  );
}

export default App;
